import { type TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { type AssetContainer } from '@babylonjs/core/assetContainer';
import { type Scene } from '@babylonjs/core/scene';
import { type Nullable } from '@babylonjs/core/types';
import { type IMesh } from '@seddi/mesh';
import { type IScene, type ISceneEntity } from '@seddi/scene';
import { type VertexDataDesc, MeshExt } from '@seddi/ui-babylon-core';

export class EcMeshLoader {
  private readonly babylonScene: Scene;

  private _assetContainer: Nullable<AssetContainer> = null;

  constructor(babylonScene: Scene) {
    this.babylonScene = babylonScene;
  }

  async loadAssetContainerAsync(
    scene: IScene,
    entity: ISceneEntity,
    parent: TransformNode,
    container: Nullable<AssetContainer> = null,
  ) {
    this._assetContainer = container;
    return this._loadAsync(scene, entity, parent);
  }

  loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode) {
    return this._loadAsync(scene, entity, parent);
  }

  // eslint-disable-next-line @typescript-eslint/require-await -- Todo
  async _loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode) {
    const component = entity.components.mesh!;
    let mesh = component.mesh as IMesh;

    if (typeof mesh === 'string') {
      const id = component.mesh as string;
      mesh = scene.meshes!.find(m => m.id === id)!;
    }

    const { geometry } = mesh;

    const positions = geometry.position!;
    const indices = geometry.indices;

    const fxGeometry: VertexDataDesc = {
      indices,
      positions,
    };
    if (geometry.normal) {
      fxGeometry.normals = geometry.normal;
    }
    if (geometry.uv_0) {
      fxGeometry.uvs = geometry.uv_0;
    }

    this.babylonScene._blockEntityCollection = Boolean(this._assetContainer);
    const babylonMesh = MeshExt.create(`${entity._id}-mesh`, this.babylonScene);
    babylonMesh._parentContainer = this._assetContainer;
    this.babylonScene._blockEntityCollection = false;
    MeshExt.applyGeometry(babylonMesh, fxGeometry);

    babylonMesh.parent = parent;
  }
}
